import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import partnerAPI from '@infrastructure/partner-api';
import { toast } from 'react-toastify';
import i18n from '@application/utilities/i18n';
export const createPartnerAsync = createAsyncThunk('partner/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await partnerAPI.createPartner(payload);
        toast.success(i18n.t('sponsorships.partnerCreatedSuccessfully'));
        return response.data;
    }
    catch (error) {
        toast.error(i18n.t('sponsorships.partnerCreationFailed'));
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updatePartnerAsync = createAsyncThunk('partner/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await partnerAPI.updatePartner(payload);
        toast.success(i18n.t('sponsorships.partnerUpdatedSuccessfully'));
        return response.data;
    }
    catch (error) {
        toast.error(i18n.t('sponsorships.partnerUpdateFailed'));
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllPartnersAsync = createAsyncThunk('partner/getAll', async (request, { rejectWithValue }) => {
    try {
        const response = await partnerAPI.getAllPartners(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPartnerByIdAsync = createAsyncThunk('partner/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await partnerAPI.getPartnerById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deletePartnerAsync = createAsyncThunk('partner/delete', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await partnerAPI.deletePartner(id);
        toast.success(i18n.t('sponsorships.partnerDeletedSuccessfully'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        toast.error(i18n.t('sponsorships.failedToDeletePartner'));
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllPartnersByCompanyAsync = createAsyncThunk('partner/getAllByCompany', async (companyIds, { rejectWithValue }) => {
    try {
        const response = await partnerAPI.getAllPartnersByCompany(companyIds);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const togglePartnerContractAsync = createAsyncThunk('partner/toggleContract', async ({ id, wasActive }, { rejectWithValue }) => {
    try {
        await partnerAPI.togglePartnerContract(id);
        toast.success(i18n.t(wasActive ? 'sponsorships.partnerDeactivatedSuccessfully' : 'sponsorships.partnerActivatedSuccessfully'));
    }
    catch (error) {
        toast.error(i18n.t('sponsorships.failedToUpdatePartnerStatus'));
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getSuggestedPeopleForPartnerAsync = createAsyncThunk('/partners/suggested-people', async (request, { rejectWithValue }) => {
    try {
        const response = await partnerAPI.getSuggestedPeopleForPartner(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
